var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fluid":""}},[(_vm.code === '1')?_c('service-tab-1'):(_vm.code === '2')?_c('service-tab-2'):(_vm.code === '3')?_c('service-tab-3'):(_vm.code === '4')?_c('service-tab-4'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }